export const OPERATORS = [
  { label: 'Equals', value: '=' },
  { label: 'Not Equals', value: '!=' },
  { label: 'Is less than', value: '<' },
  { label: 'Is greater than', value: '>' },
  { label: 'Is less than or equal to', value: '<=' },
  { label: 'Is greater than or equal to', value: '>=' },
  { label: 'Between', value: 'BETWEEN' },
  { label: 'Starts with', value: 'LIKE_START' },
  { label: 'Contains', value: 'LIKE_CONTAINS' },
  { label: 'Does not Contain', value: 'NOT_LIKE_CONTAINS' },
  { label: 'In', value: 'IN' },
  { label: 'Not In', value: 'NOT IN' },
  { label: 'Is Empty', value: 'IS NULL' },
  { label: 'Is Not Empty', value: 'IS NOT NULL' },
];

export const LOGIC_OPERATORS = [
  { label: 'AND', value: 'AND' },
  { label: 'OR', value: 'OR' }
];